// See index.css for css constants
export const zIndex = {
  zIndexResizeHandle: 100,
  zIndexBackdrop: 999989,
  zIndexDropdown: 999990,
  zIndexModal: 999998,
  zIndexPortalDropdown: 999999,
  zIndexToast: 1000000,
  zIndexViewerTools: 1000001, // needs to be higher than the Menu bar
  zIndexViewerToolsFocused: 1000002, // needs to be higher than the Menu bar and zIndexViewerTools
} as const;
